import React from 'react'

import { Asterisk, Eye, Pencil, Plus } from 'lucide-react';
import { Select, Row, Col, FormGroup, Label, Input, Button, DefaultTooltip, Switch, FormSection, DefaultTable } from 'twyne-new.ui';

const TcpaConfirmationForm = ({data, integrationData, onChange, disabled, onCustomFieldClick}) => {
  const extraFields = integrationData.extraFields || []
  const fieldOptions = extraFields.map((field) => ({value:field.key, label: field.name}))
  
  const handleChangeInput = (idx, key, value) => {
    const fields = data.fields
    fields[idx][key] = value;
    onChange('fields', fields)
  }

  const handleEnableAlwaysShow = (e) => {
    let checked = e.target.checked
    onChange('alwaysShow', checked)
  }

  const handleEnableTrustedForm = (e) => {
    let checked = e.target.checked
    
    if(checked) {
      onChange('trustedform', checked)
      onChange('trustedform_cfid', `${data.cfid}_trustedform`)
    } else {
      onChange('trustedform', false)
      onChange('trustedform_cfid', '')
    }
    
  }

  const handleEnableLeadId = (e) => {
    let checked = e.target.checked
    
    if(checked) {
      onChange('leadid', checked)
      onChange('leadid_cfid', `${data.cfid}_leadid`)
    } else {
      onChange('leadid', false)
      onChange('leadid_cfid', '')
    }
    
  }

  const handleChangeCustomField = cf => {
    const cfid = cf ? cf.value : null
    onChange('cfid', cfid)
    const { leadid, trustedform } = data
    leadid && onChange('leadid_cfid', `${cfid}_leadid`)
    trustedform && onChange('trustedform_cfid', `${cfid}_trustedform`)
  }

  if(!data.fields)
    onChange("fields", buildFields())

  const handleCustomFieldClick = () => {
    onCustomFieldClick({      
      customFieldOpen: true
    })
  }

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Title</Label>
          <Input type="text" value={data.title || ''}
            onChange={(e) => onChange('title', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>
            Custom Field
          </Label>
          <div className="flex items-center justify-center gap-1">
            <Select name="type" value={data.cfid || ''} options={fieldOptions}
              onChange={handleChangeCustomField} disabled={disabled} />
            <Button disabled={disabled} onClick={handleCustomFieldClick} color="accent">
              <Plus size={14} />
              Add
            </Button>
          </div>
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Confirmation Text</Label>
          <Input type="text" value={data.confirmText || ''}
            onChange={(e) => onChange('confirmText', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Privacy Subtext</Label>
          <Input type="text" value={data.privacyDisclaimer || ''}
            onChange={(e) => onChange('privacyDisclaimer', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row className='mt-4'>
      <Col size="2">
        <FormGroup>
          <Label>Always Visible?</Label>
          <Switch
            onChange={(e) => handleEnableAlwaysShow(e)}
            checked={data.alwaysShow || false}
          />
          </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>Trusted Form?</Label>
          <Switch
            onChange={(e) => handleEnableTrustedForm(e)}
            checked={data.trustedform || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>LeadId?</Label>
          <Switch
            onChange={(e) => handleEnableLeadId(e)}
            checked={data.leadid || false}
            disabled={disabled}
          />
          </FormGroup>
      </Col>
      {renderFields({ disabled, data, handleChangeInput })}
    </Row>
  </>
}

const buildFields = () => {
  const fieldList = ['firstName','lastName','email','dob','address1','address2','city','state','country','zip','phone','gender']
  const fields = []
  fieldList.forEach((field) => {
    fields.push({
      label: field,
      field: field,
      visible: true,
      required: false,
      editable: false
    })
  })

  return fields
}

const renderButtonAction = (idx, fields, property, Icon, handleClickRemovePostData, disabled) => {
  const value = fields[idx][property]
  const color = value ? "accent" : "danger"

  return (
    <DefaultTooltip content={`${value ? "is" : "not"} ${property}`}>
      <Button size='sm' variant='ghost' disabled={disabled} color={color} onClick={e => handleClickRemovePostData(idx, property, !value)}>
        <Icon size='16' />
      </Button>
    </DefaultTooltip>
  )
}

const renderFields = ({ disabled, data, handleChangeInput }) => {
  const fields = data.fields || [];

  const columns = [
    {
      dataField: 'label',
      text: 'Label',
      formatter: (value, row, index) => (
        <Input
          value={value}
          onChange={e => handleChangeInput(index, 'label', e.target.value)}
          placeholder="Label"
          disabled={disabled}
        />
      ),
    },
    {
      dataField: 'visible',
      text: '',
      className: 'w-12',
      formatter: (_, row, index) => (
        <div className="flex items-center justify-center gap-1">
          {renderButtonAction(index, fields, 'visible', Eye, handleChangeInput, disabled)}
          {renderButtonAction(index, fields, 'required', Asterisk, handleChangeInput, disabled)}
          {renderButtonAction(index, fields, 'editable', Pencil, handleChangeInput, disabled)}
        </div>
      ),
    },
  ]

  return (
    <Col size="12">
      <FormSection>
        Fields Configuration
      </FormSection>
      <DefaultTable
        className='max-h-80 overflow-y-auto'
        data={fields}
        columns={columns}
        noDataIndication={() => 'No fields to show.'}
      />
    </Col>
  );
}

export default TcpaConfirmationForm;
